const sliderFunc = () => {
  const sliders = document.querySelectorAll('.js-slider-vertical');
  if (sliders.length) {
    sliders.forEach(slider => {
      const content = slider.querySelector('.js-slider-content');
      const firstElement = content.children[0];
      if (firstElement) {
        const count = content.children.length;
        const countVisible = Math.ceil(
          content.offsetHeight / firstElement.offsetHeight,
        );

        function checkMovement(slider, progress) {
          const {
            iter
          } = slider.dataset;
          if (progress > 0) {
            return count - iter > countVisible;
          }
          return iter > 0;
        }

        function updateSlider(slider, progress) {
          if (checkMovement(slider, progress)) {
            slider.dataset.iter = parseInt(slider.dataset.iter, 10) + progress;
            const {
              iter
            } = slider.dataset;
            const margin = (firstElement.offsetHeight - 1) * iter;
            firstElement.style.marginTop = `-${margin}px`;
          }
        }
        slider.querySelector('.js-slider-up').addEventListener('click', () => {
          updateSlider(slider, 1);
        });
        slider
          .querySelector('.js-slider-down')
          .addEventListener('click', () => {
            updateSlider(slider, -1);
          });
      }
    });
  }
};
export default sliderFunc;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/bnppblog-chisel/src/scripts/modules/slider.js